import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { RollbackOutlined } from "@ant-design/icons"
import { Node } from "@antv/x6"
import { Button } from "antd"
import { useContext } from "react"

interface RollBackButtonProps {
  node: Node
  override: boolean
  onOverrideChange: (isOverride: boolean) => void
}

export const RollBackButton = (props: RollBackButtonProps) => {
  const {node, override, onOverrideChange} = props;
  const {changeCellProps, template, isTemplate} = useContext(FlowsheetContext)

  const removeOverride = () => {
    const templateCells = template?.tempCells || []
    const target = templateCells.find(item => item.id === node.id)
    if (target) {
      const {size, position} = target
      node.setSize(size)
      node.setPosition(position)
      changeCellProps(node.id, {...target.data, override: false})
      onOverrideChange(false)
    }
  }

  if (!(!isTemplate && override)) return null;

  return <Button onClick={removeOverride} icon={<RollbackOutlined />}/>
}